import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  LayoutDashboard,
  Store,
  Building2,
  BarChart3,
  Settings,
  LogOut,
  ShieldCheck,

  // ✅ NEW ICONS ADDED
  Package,
  Users,
  ArrowRightLeft,
  CreditCard,
  PieChart,
} from "lucide-react";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const menus = [
    {
      name: "Dashboard",
      icon: LayoutDashboard,
      path: "/dashboard",
    },
    {
      name: "Create Store",
      icon: Store,
      path: "/create-store",
    },
    {
      name: "Inventory",
      icon: Package,
      path: "/inventory",
    },
    {
      name: "Stores Report",
      icon: Building2,
      path: "/stores",
    },

    // 🔥 NEW MODULES ADDED
    
    {
      name: "Sales Report",
      icon: Package,
      path: "/sales",
    },
    {
      name: "Customers",
      icon: Users,
      path: "/customers",
    },
    {
      name: "Employees",
      icon: Users,
      path: "/employees",
    },
    {
      name: "Expense",
      icon: Users,
      path: "/expenses",
    },
    {
      name: "Eye Testing",
      icon: Users,
      path: "/eye-testing",
    },
    {
      name: "Closing Stock",
      icon: PieChart,
      path: "/report/closing-stock",
    },
    {
      name: "Profit & Loss",
      icon: CreditCard,
      path: "/billing",
    },
  
  ];

  const handleLogout = () => {
    localStorage.removeItem("role");
    navigate("/");
  };

  return (
   <aside className="hidden md:flex flex-col w-72 min-h-screen bg-white border-r border-slate-200 shadow-sm">

  {/* Logo */}
  <div className="p-6 border-b border-slate-200 bg-gradient-to-r from-sky-50 to-blue-50">
    <div className="flex items-center gap-3">
      <div className="bg-gradient-to-r from-blue-600 to-cyan-500 p-3 rounded-xl shadow">
        <ShieldCheck size={24} className="text-white" />
      </div>

      <div>
        <h2 className="text-slate-800 font-bold text-lg">
          Shruti Eye Care
        </h2>

        <p className="text-slate-500 text-xs">
          Super Admin ERP
        </p>
      </div>
    </div>
  </div>

  {/* Menu */}
  <div className="flex-1 p-4 space-y-2 overflow-y-auto">

    {menus.map((item) => {
      const Icon = item.icon;
      const active = location.pathname === item.path;

      return (
        <Link key={item.path} to={item.path}>
          <motion.div
            whileHover={{ x: 4 }}
            whileTap={{ scale: 0.98 }}
            className={`flex items-center gap-3 p-3 rounded-xl transition-all duration-300 font-medium
            ${
              active
                ? "bg-gradient-to-r from-blue-600 to-cyan-500 text-white shadow-md"
                : "text-slate-700 hover:bg-sky-50 hover:text-blue-600"
            }`}
          >
            <Icon size={20} />
            <span>{item.name}</span>
          </motion.div>
        </Link>
      );
    })}
  </div>

  {/* User Card */}
  <div className="p-4 border-t border-slate-200">


    <button
      onClick={handleLogout}
      className="w-full flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 transition-all duration-300 p-3 rounded-xl text-white font-medium shadow-sm"
    >
      <LogOut size={18} />
      Logout
    </button>

  </div>

</aside>
  );
}